import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  BodySmall,
  ControlButton,
  Link,
  HeaderMedium,
  iconSizes,
  ShareIcon,
  Toolbar
} from '@animoto/components/lib/es/design-system';
import './VideoDetails.module.css';

export default function VideoDetails({
  description,
  displayDate,
  isMobile,
  isSharingEnabled,
  onOpenShareModal,
  producerName,
  title
}) {
  const maxLength = isMobile ? 80 : 160;
  const showFullDescription = description.length <= maxLength;
  const [isTruncated, setIsTruncated] = useState(!showFullDescription);
  const linkText = isTruncated ? 'Show more' : 'Show less';

  let shownDescription;

  if (!isTruncated) {
    shownDescription = description;
  } else {
    const trimmedStr = !isTruncated ? description : description.slice(0, maxLength + 1);
    shownDescription = trimmedStr.substr(0, Math.min(trimmedStr.length, trimmedStr.lastIndexOf(' ')));
  }

  const onHandleClick = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div id="details" styleName="wrapper">
      <div>
        <HeaderMedium styleName="title">{title}</HeaderMedium>
        <div styleName="details">
          {producerName && (
            <BodySmall color="secondary" styleName="divider">{producerName}</BodySmall>
          )}
          {displayDate && (
            <BodySmall color="secondary">{displayDate}</BodySmall>
          )}
        </div>
        {description && (
          <>
            <BodySmall>{shownDescription}</BodySmall>
            {!showFullDescription && (
              <Link href="#details" onClick={onHandleClick} size="small" styleName="link">{linkText}</Link>
            )}
          </>
        )}
      </div>
      <div styleName="button-wrapper">
        <Toolbar isSmall>
          <ControlButton
            className="s-sharing-button"
            inToolbar
            isDisabled={!isSharingEnabled}
            onClick={onOpenShareModal}
          >
            <ShareIcon size={iconSizes.SMALL} />
            Share
          </ControlButton>
        </Toolbar>
      </div>
    </div>
  );
}

VideoDetails.propTypes = {
  description      : PropTypes.string,
  displayDate      : PropTypes.string,
  isMobile         : PropTypes.bool.isRequired,
  isSharingEnabled : PropTypes.bool.isRequired,
  onOpenShareModal : PropTypes.func.isRequired,
  producerName     : PropTypes.string,
  title            : PropTypes.string.isRequired
};
VideoDetails.defaultProps = {
  displayDate  : '',
  description  : '',
  producerName : ''
};
